
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { practicesOptions, procoDocsDocumentTypesOptions } from '../../../../../lib/systemData'
import { uploadProcodocsDocumentApi } from '../../../../../lib/fetchApi'
import { notificationActions } from '../../../../../store/notifications'
import { caseActions } from '../../../../../store/case'
import {  returnOnlyPracticesThatAreOnTheCase } from '../../../../../lib/misc'
import CustomSelect from '../../../../common/interactive/CustomSelect'
import Button from '../../../../common/Button'
import { isManagingAttorney } from '../../../../../lib/primaryItemScripts'

import classes from './DocumentsTabListItemUploading.module.css'
import DocumentEditable from './DocumentEditable'
import { procoDocsFunctions } from '../../../../../lib/procoDocs'

const DocumentsTabListItemUploading = ({data, file, removeFile}) => {
    const dispatch = useDispatch()

    const userToken = useSelector(state => state.user.token)
    const activeCase = useSelector(state => state.case.activeCase)
    
    const [isLoading, setIsLoading] = useState(false)
    const [typeBySelect, setTypeBySelect] = useState(null)
    const [selectedDocumentTypeId, setSelectedDocumentTypeId] = useState(null)

    const [selectedPracticeId, setSelectedPracticeId] = useState([])
    const [practicesFilteredOptions, setPracticesFilteredOptions] = useState([])

    const selectedProcoDocsAttorney = useSelector(state => state.attorney.selectedProcoDocsAttorney)

    const [itemLockState, setItemLockState] = useState(selectedProcoDocsAttorney ? 
        activeCase?.attorneys?.find(attorney => attorney.id == selectedProcoDocsAttorney)?.patient_represented == 1 ? false : true 
        : 
        isManagingAttorney(activeCase)?.patient_represented == 1 ? false : true)


    function setSelectedPracticeHandler(value) {
        let isRepresented = selectedProcoDocsAttorney ? 
            activeCase?.attorneys?.find(attorney => attorney.id == selectedProcoDocsAttorney)?.patient_represented == 1 ? true : false 
        : 
            isManagingAttorney(activeCase)?.patient_represented == 1 ? true : false

        // if the practice is selected and the attorney is represented, check if the HIPPA or LOR document is uploaded
        if (value && isRepresented) {

            if (procoDocsFunctions.isHIPPAOrLORUploaded(value, activeCase.procodocs_documents)) {
                setItemLockState(false)
            } else {
                setItemLockState(true)
            }
        }
    }
    // let types = procoDocsDocumentTypesOptions(true)


    let practices = practicesOptions()

    // const saveFileHandler = async () => {
    //     setIsLoading(true)
        
    //     if (file) {
    //         let formData = new FormData();

    //         formData.append("file", file.file_to_upload);
    //         formData.append("procodocs_document_type_id", selectedDocumentTypeId)
    //         formData.append("practices", selectedPracticeId)

    //         if (isManagingAttorney(activeCase)?.patient_represented == 1) {
    //             formData.append("is_ecm_locked", 0)
    //         }

    //         if (!itemLockState) {
    //             formData.append("is_ecm_locked", 0)
    //         }
            
    //         formData.append("case_attorney_id", isManagingAttorney(activeCase)?.id)

    //         let reqBody = formData     

    //         const upload = await uploadProcodocsDocumentApi(userToken, activeCase.case.id, reqBody)


    //         if (upload && upload.errorMessage) {
    //             dispatch(notificationActions.setError(upload))                
    //         } else {
    //             // /success 

    //             removeFile(data.id)                
                
    //             // add item to store dispatch
    //             dispatch(caseActions.pushItemToProcoDocuments(upload))
    //         }
    //     }

    //     setIsLoading(false)
    // }

    // const documentTypeHandler = (value) => {
    //     setSelectedDocumentTypeId(value.data.value)
    //     setTypeBySelect(value.option.type)
    // }

    // const changePracticesHandler = (value) => {
    //     setSelectedPracticeId(value.data.value)
    // }

    useEffect(() => {
        if (activeCase && activeCase.practices && activeCase.practices.length > 0) {
            let items = returnOnlyPracticesThatAreOnTheCase(activeCase, practices)
            setPracticesFilteredOptions(items)
        }
        

    }, [activeCase])

    const removefileHandler = () => {
        removeFile(data.id)
    }

    const unlockLockHandler = () => {
        setItemLockState(prev => prev = !prev)
    }

    return <tr className={classes.tr}>
        {/* name of file and controls  */}
        <td>
            <div className='flex-vertical-center'>
                {data.file && <>{data.file}</>}
                <div className='flex-container'>
                    <Button click={unlockLockHandler} btnStyle={'btn_simple'} title={itemLockState ? 'Unlock Document' : 'Lock Document'}>
                        <div className={itemLockState ? classes.locked : ''}><i className="ti ti-lock"></i></div>
                    </Button>
                    <Button click={removefileHandler} btnStyle={'btn_simple'} color={'danger'} title={'delete file'}>
                        <i className='ti ti-trash'></i>
                    </Button>
                </div>
            </div>
        </td>

        {/* date is now because now was the time when the document was uplaoded!  */}
        <td>Now</td>

        {/* user name  */}
        <td>{data.uploader && data.uploader}</td>

        {/* source  */}
        <td>ProCo</td>    

        <DocumentEditable data={data} file={file} removeFile={removeFile} caseAttorneyId={selectedProcoDocsAttorney ? selectedProcoDocsAttorney : isManagingAttorney(activeCase)?.id} selectedPractice={setSelectedPracticeHandler}/>  

        {/* document type  */}
        {/* <td>
            <CustomSelect optionsData={types} action={documentTypeHandler} preSelectedValue={selectedDocumentTypeId} thin_select={true}/>
        </td> */}
            
        {/* practice --- this is available only if the type is practice  */}
        {/* <td>   
            {typeBySelect == 'Practice' && practicesFilteredOptions && <CustomSelect optionsData={practicesFilteredOptions} preSelectedValue={selectedPracticeId} action={changePracticesHandler}  thin_select={true}/>}
            {typeBySelect !== 'Practice' && <>-</>} 
        </td> */}

        {/* verify, no verify on uploading */}
        {/* <td></td> */}

        {/* save document  */}
        {/* <td><Button btnStyle={'btn_small'} color={'white'} click={saveFileHandler} isLoading={isLoading} isDisabled={!selectedDocumentTypeId}><i className='ti ti-check'></i>Save</Button></td> */}
    </tr>
}

export default DocumentsTabListItemUploading